























































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { deleteElement } from "@/api/delite/delite-element";
import { menu } from "@/config/host.config";

import InputSearch from "@/components/app/search/input-search.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";

import { IBar } from "@/@types/menu/bars/bars";

@Component({
  components: {
    InputSearch,
    ChangeDeliteButtons,
  },
})
export default class BarsList extends Vue {
  @Prop({ type: Array, default: () => [] }) barList!: Array<IBar>;
  @Inject({ from: "barFolder", default: null }) readonly folder!: string;
  search = "";
  id = "";

  get bars(): Array<IBar> {
    return this.barList.filter((item) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  deleteBar(id: string): void {
    const url = menu.bars;
    deleteElement(id, url)
      .then(() => {
        this.$emit("deleteBar", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      })
      .catch((e) => {
        console.log(e.message);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.empty400")),
          type: "warn",
        });
      });
  }

  async changeElement(id: string, type: boolean): Promise<void> {
    if (type) {
      this.$emit("changeBar", id);
      return;
    }

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("HotelInfo.confirm.delete")),
        }
      );

      if (result === true) this.deleteBar(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }
}
